import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ViewNetTermsCTA } from "./ctas";

export const Net60BasicsIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (_context) => {
      return NET_60_TERMS(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [NET_60_TERMS_EXPLANATION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (_context) => {
        return ViewNetTermsCTA(strictLocalize).label;
      },
      linkBuilder: (_context) => {
        return ViewNetTermsCTA(strictLocalize).getLink?.();
      },
    },
  };
};

const NET_60_TERMS = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "About Net 60 payment terms",
    description: {
      text: "Title for the answer of the question 'About Net 60 payment terms?'",
    },
  });

const NET_60_TERMS_EXPLANATION = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "Net 60 payment terms are a payment option we offer on Faire that allows you to buy new inventory now, and pay for it 60 days later. We offer net 60 terms so you can buy the optimal amount of inventory for your store, while managing your cash flow. You can view your available terms by clicking the button below or read the help center article for more details. Please contact us if you need any further help.",
    description: {
      text: "Description for the answer of the question 'About Net 60 payment terms?'",
    },
  });
